import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileUpload,
  FaUserCheck,
  FaSearch,
  FaClipboardCheck,
  FaTruck,
} from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";
import drivreCar from "../../assets/images/new22.jpg";
import "./Transportpartner.css";
import LandingSection from "../landingSection/LandingSection";
import heroPhoto from "../../assets/images/cars.jpg";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO";
import AppDownloadSection from "../heroSection/AppDownloadSection";

export default function Transportpartner() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const renderCard = (icon, titleKey, textKey, delay = 0) => (
    <Col xs={12} sm={6} lg={3} data-aos="fade-up" data-aos-delay={delay}>
      <Card className="h-100 border-0 shadow-lg p-4 rounded-4 text-center animate-card">
        {icon && <div className="mb-3 fs-1 text-orange">{icon}</div>}
        {titleKey && (
          <Card.Title className="mb-2 text-orange fw-bold fs-6">
            {t(titleKey)}
          </Card.Title>
        )}
        <Card.Text className="text-muted fs-6">{t(textKey)}</Card.Text>
      </Card>
    </Col>
  );

  return (
    <>
      <SEO
        title="TransCirox – Transportpartner werden | Als Fahrer Geld verdienen"
        description="Werden Sie Transportpartner bei TransCirox und verdienen Sie Geld mit Ihrem Fahrzeug. Registrieren Sie sich jetzt als Fahrer oder Transportunternehmen."
        keywords="Transportpartner, Fahrer werden, Transport Job, Fahrzeug, Transportunternehmen, Kuriertransport Job"
      />
      <NavbarMenu />
      {/* Hero Section */}
      <LandingSection
        backgroundImage={heroPhoto}
        showNavbar={true}
        showTopbar={false}
        customHeight="80vh"
        showQuoteForm={false}
        showCTAButton={true}
      >
        <div className="text-white header-content" data-aos="fade-down">
          <h6 className="display-4 fw-bold landing-title">
            <span className="typing-word">
              {t("hero.title")}{" "}
              <span className="text-orange">{t("hero.title2")}</span>
            </span>
          </h6>
        </div>
      </LandingSection>
      <div className="freight-platform-section py-5">
        <Container>
          <section
            className="text-center mission-section mb-4"
            data-aos="fade-up"
          >
            <Container>
              <h6 className="transport-par fw-bold">
                {t("overviews.title")}{" "}
                <span className="text-white">{t("overviews.title2")}</span>{" "}
                {t("overviews.subtitle")}
              </h6>
            </Container>
          </section>
          <Row className="align-items-center py-5">
            <Col md={6} data-aos="fade-right">
              <img
                src={drivreCar}
                alt={t("image_alt.sendung")}
                className="img-fluid rounded shadow info-img"
              />
            </Col>
            <Col md={6} data-aos="fade-left">
              <h4 className="text-orange mb-4">{t("benefits.title")}</h4>
              <ul className="list-unstyled">
                {[
                  {
                    title: t("benefits.direct_transports.title"),
                    text: t("benefits.direct_transports.text"),
                  },
                  {
                    title: t("benefits.express_deliveries.title"),
                    text: t("benefits.express_deliveries.text"),
                  },
                  {
                    title: t("benefits.round_trip.title"),
                    text: t("benefits.round_trip.text"),
                  },
                  {
                    title: t("benefits.avoid_empty_trips.title"),
                    text: t("benefits.avoid_empty_trips.text"),
                  },
                ].map((item, index) => (
                  <li className="mb-3" key={index}>
                    <FaCheckCircle className="text-orange me-2" />
                    <strong>{item.title}:</strong> {item.text}
                  </li>
                ))}
              </ul>
            </Col>
          </Row>

          <h4
            className="text-orange text-center fw-bold py-4"
            data-aos="zoom-in"
          >
            {t("platform_advantages.title")}
          </h4>
          <Row className="gx-4 gy-4 justify-content-center">
            {renderCard(
              <FaCheckCircle />,
              "platform_advantages.high_quality.title",
              "platform_advantages.high_quality.text",
            )}
            {renderCard(
              <FaCheckCircle />,
              "platform_advantages.timely_payments.title",
              "platform_advantages.timely_payments.text",
              100,
            )}
            {renderCard(
              <FaCheckCircle />,
              "platform_advantages.diverse_orders.title",
              "platform_advantages.diverse_orders.text",
              200,
            )}
            {renderCard(
              <FaCheckCircle />,
              "platform_advantages.free_usage.title",
              "platform_advantages.free_usage.text",
              300,
            )}
          </Row>

          <Row className="justify-content-center my-5" data-aos="fade-up">
            <Col md={12}>
              <h4 className="text-orange text-center fw-bold py-3">
                {t("unique_advantage.title")}{" "}
                <span className="fs-5">{t("unique_advantage.highlight")}</span>
              </h4>
            </Col>
          </Row>

          <Row className="gx-4 gy-4 justify-content-center">
            {renderCard(null, null, "unique_advantage.access_without_fees")}
            {renderCard(
              null,
              null,
              "unique_advantage.attractive_for_small_businesses",
            )}
          </Row>

          <Row className="justify-content-center py-5" data-aos="fade-up">
            <Col md={12}>
              <h4 className="text-orange text-center fw-bold">
                {t("requirements.title")}
              </h4>
              <p className="text-muted text-center">
                {t("requirements.subtitle")}
              </p>
            </Col>
          </Row>

          <Row className="gx-4 gy-4 justify-content-center py-4">
            {renderCard(
              null,
              "requirements.driver_license.title",
              "requirements.driver_license.text",
            )}
            {renderCard(
              null,
              "requirements.business_registration.title",
              "requirements.business_registration.text",
            )}
            {renderCard(
              null,
              "requirements.insurance.title",
              "requirements.insurance.text",
            )}
            {renderCard(
              null,
              "requirements.vehicle.title",
              "requirements.vehicle.text",
            )}
          </Row>

          <Row className="justify-content-center py-2">
            <p className="text-orange text-center">
              {t("post_registration.text")}
            </p>
          </Row>

          <Row className="justify-content-center py-5" data-aos="zoom-in">
            <Col md={10}>
              <Card className="TransCirox-card text-center border-0 shadow py-4 rounded-4">
                <h5>
                  {t("create_account.title")}{" "}
                  <span className="fw-bold text-orange">
                    {t("create_account.highlight")}
                  </span>
                  ?
                </h5>
                <p>{t("create_account.steps")}</p>
                <p>{t("create_account.enter_info")}</p>
                <Row md={4} className="justify-content-center">
                  <Button
                    variant="warning"
                    size="lg"
                    className="bg-orange-500 text-white mt-3"
                    onClick={() => navigate("/register/driver")}
                  >
                    {t("create_account.button")}
                  </Button>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-center py-5" data-aos="fade-up">
            <Col md={12}>
              <h4 className="text-orange text-center fw-bold">
                {t("upload_documents.title")}
              </h4>
              <p className="text-orange text-center fw-bold">
                {t("upload_documents.text")}
              </p>
            </Col>
          </Row>

          <Row className="gx-4 gy-4 justify-content-center">
            {renderCard(
              <FaUserCheck />,
              "steps.create_account.title",
              "steps.create_account.text",
            )}
            {renderCard(
              <FaSearch />,
              "steps.search_orders.title",
              "steps.search_orders.text",
            )}
            {renderCard(
              <FaClipboardCheck />,
              "steps.receive_order.title",
              "steps.receive_order.text",
            )}
            {renderCard(
              <FaTruck />,
              "steps.perform_transport.title",
              "steps.perform_transport.text",
            )}
          </Row>
        </Container>
      </div>

      <AppDownloadSection />

      <Footer />
    </>
  );
}
